<template>
  <NUIButton
    :obj="this.calculations"
    :displayType="'icon'"
  />
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import NUIButton from './nelsonUI/NUIButton.vue';

export default {
  data () {
    return {
      calculations: {
        label: 'Calculations',
        icon: 'table',
        value: 'calculations',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        func: this.handleCalculations,
      }
    };
  },
  methods: {
    handleCalculations () {
      useModalStore().showModal('calculations');
    }
  },
  components: {
    NUIButton
  }
};
</script>

<style scoped>
.calculations-button {
  width: 100px;
  background-color: yellowgreen;
  cursor: pointer;
}
</style>